import api from '@/api';

export default {
  namespaced: true,
  state: {
    teachers: [],
    currentTeacher: null,
    isLoading: false,
      teacherClasses: [], 
    error: null,
    pagination: {
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      perPage: 10,
      from: 0,
      to: 0
    },
    filters: {
      search: '',
      gender: null
    }
  },
  mutations: {
    SET_TEACHERS(state, teachers) {
      state.teachers = teachers;
    },
    SET_CURRENT_TEACHER(state, teacher) {
      state.currentTeacher = teacher;
    },
    SET_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
    SET_TEACHER_CLASSES(state, classes) {
    state.teacherClasses = classes; 
  },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_PAGINATION(state, pagination) {
      state.pagination = pagination;
    },
    SET_FILTERS(state, filters) {
      state.filters = filters;
    },
    ADD_TEACHER(state, teacher) {
      state.teachers.unshift(teacher);
    },
    UPDATE_TEACHER(state, updatedTeacher) {
      const index = state.teachers.findIndex(t => t.id === updatedTeacher.id);
      if (index !== -1) state.teachers.splice(index, 1, updatedTeacher);
    },
    DELETE_TEACHER(state, teacherId) {
      state.teachers = state.teachers.filter(t => t.id !== teacherId);
    }
  },
  actions: {
    async fetchTeachers({ commit, state }, { page = 1, per_page = 10 } = {}) {
        commit('SET_LOADING', true);
        try {
          const response = await api.get('/teachers', {
            params: {
              page: page || state.pagination.currentPage,
              per_page: per_page || state.pagination.perPage,
              search: state.filters.search,
              gender: state.filters.gender
            }
          });
          
          commit('SET_TEACHERS', response.data.data);
          commit('SET_PAGINATION', {
            currentPage: response.data.meta.current_page,
            totalPages: response.data.meta.last_page,
            totalItems: response.data.meta.total,
            perPage: response.data.meta.per_page,
            from: response.data.meta.from,
            to: response.data.meta.to
          });
        } catch (error) {
          commit('SET_ERROR', error.response?.data?.message || error.message);
          throw error;
        } finally {
          commit('SET_LOADING', false);
        }
      },
    fetchTeacher({ commit }, id) {
      commit('SET_LOADING', true);
      return api.get(`/teachers/${id}`)
        .then(response => {
          commit('SET_CURRENT_TEACHER', response.data.data);
        })
        .catch(error => {
          commit('SET_ERROR', error.response?.data?.message || error.message);
          throw error;
        })
        .finally(() => commit('SET_LOADING', false));
    },

   createTeacher({ commit }, formData) {
  commit('SET_LOADING', true);

  return api.post('/teachers', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Accept': 'application/json'
    }
  })
  .then(response => {
    commit('ADD_TEACHER', response.data.data);
    return response.data;
  })
  .catch(error => {
    commit('SET_ERROR', error.response?.data?.message || error.message);
    throw error;
  })
  .finally(() => commit('SET_LOADING', false));
},

updateTeacher({ commit }, { id, teacherData }) {
  commit('SET_LOADING', true);

  return api.post(`/teachers/${id}`, teacherData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Accept': 'application/json'
    }
  })
  .then(response => {
    commit('UPDATE_TEACHER', response.data.data);
    return response.data;
  })
  .catch(error => {
    commit('SET_ERROR', error.response?.data?.message || error.message);
    throw error;
  })
  .finally(() => commit('SET_LOADING', false));
},

    deleteTeacher({ commit }, id) {
        commit('SET_LOADING', true);
        return api.delete(`/teachers/${id}`)
          .then(() => {
            commit('DELETE_TEACHER', id);
            return Promise.resolve();
          })
          .catch(error => {
            commit('SET_ERROR', error.response?.data?.message || error.message);
            return Promise.reject(error);
          })
          .finally(() => commit('SET_LOADING', false));
      },
async fetchTeacherClasses({ commit }, teacherId) {
  try {
    commit('SET_LOADING', true);
    const response = await api.get(`/teachers/${teacherId}/classes`);
    console.log('API Response:', response.data); // Add this line
    commit('SET_TEACHER_CLASSES', response.data.data || response.data); // Handle both formats
    return response.data;
  } catch (error) {
    console.error('Error:', error);
    throw error;
  } finally {
    commit('SET_LOADING', false);
  }
},

  async fetchTeacherClassExams({ commit }, { teacherId, classId, exam_type, exam_date }) {
    try {
      commit('SET_LOADING', true);
      const response = await api.get(`/teachers/${teacherId}/classes/${classId}/exams`, {
        params: {
          exam_type,
          exam_date
        }
      });
      return response.data.data || response.data;
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || error.message);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  
    setFilters({ commit, dispatch }, filters) {
      commit('SET_FILTERS', filters);
      dispatch('fetchTeachers');
    }
  },
  getters: {
    teachers: state => state.teachers,
      teacherClasses: state => state.teacherClasses || [],
    teacher: state => state.currentTeacher,
    isLoading: state => state.isLoading,
    error: state => state.error,
    pagination: state => state.pagination,
    maleTeachers: state => state.teachers.filter(t => t.gender === 'M'),
    femaleTeachers: state => state.teachers.filter(t => t.gender === 'F')
  }
};